<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @todoPaid="todoPaidFun"
        @todoCheck="todoCheckFun"
        @todoReimburse="todoReimburseFun"
        @managePayer="managePayerFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.payerName"
              placeholder="请输入付款方名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.unitName"
              placeholder="请输入收款方名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.searchStartDate"
              type="date"
              placeholder="选择付款开始日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.searchEndDate"
              type="date"
              placeholder="选择付款结束日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="2">
            <el-select
              v-model="masterList.tableQuery.search.payMethod"
              placeholder="请选择付款方式"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in payMethodOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-select
              v-model="masterList.tableQuery.search.isReimburse"
              placeholder="请选择是否报销"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in isReimburseOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择单据状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>

          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun()"
        @edit="editFun(arguments)"
        @remove="removeFun(arguments)"
        @check="checkFun(arguments)"
        @unCheck="unCheckFun(arguments)"
        @reimburse="reimburseFun(arguments)"
        @print="printFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 修改 -->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 红字新增修改 -->
    <add-edit-red-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogEditRedVisible"
      @reloadData="loadTableData()"
    />

    <!-- 报销 -->
    <reimburse-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogReimburseVisible"
      @reloadData="loadTableData()"
    />

    <!-- 打印 -->
    <print-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogPrintVisible"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
    />

    <!-- 待付款列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待付款清单"
      @reloadData="loadTableData()"
    />

    <!-- 待复核付款单列表 -->
    <task-check-dialog
      :dialog-visible.sync="dialogTaskCheckVisible"
      dialog-title="待复核的付款单"
      @reloadData="loadTableData()"
    />

    <!-- 待报销付款单列表 -->
    <task-reimburse-dialog
      :dialog-visible.sync="dialogTaskReimburseVisible"
      dialog-title="待报销的付款单"
      @reloadData="loadTableData()"
    />

    <!-- 付款方管理列表 -->
    <payer-list-dialog
      :dialog-visible.sync="dialogManagePayerVisible"
      dialog-title="付款方清单"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 修改
import addEditDialog from './components/addEditDialog'
// 红字新增修改
import addEditRedDialog from './components/addEditRedDialog'
// 报销
import reimburseDialog from './components/reimburseDialog'
// 打印
import printDialog from './components/printDialog'
// 查看
import viewDialog from './components/viewDialog'
// 待付款列表
import taskListDialog from './components/taskListDialog'
// 待复核付款单列表
import taskCheckDialog from './components/taskCheckDialog'
// 待报销分款单列表
import taskReimburseDialog from './components/taskReimburseDialog'
// 付款方管理列表
import payerListDialog from '@/views/fundsModule/payer/listDialog'
import { getUserId } from '@/utils/auth'
// 数据请求
import { loadPaymentVoucherListDataApi, loadPaymentVoucherExportDataApi, saveOrUpdatePaymentVoucherApi, countPaymentVoucherTodoNumberApi } from '@/api/paymentVoucher'
import { countPayableTodoNumberApi } from '@/api/payable'
export default {
  name: 'PaymentVoucher',
  components: {
    CustomTable,
    TableOperation,
    addEditDialog,
    addEditRedDialog,
    reimburseDialog,
    printDialog,
    viewDialog,
    taskListDialog,
    taskCheckDialog,
    taskReimburseDialog,
    payerListDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'payment_voucher_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['payment_voucher_add'],
            prop: 'add',
            label: '红字新增',
            method: 'add'
          },
          {
            permissionSigns: ['payment_voucher_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['payment_voucher_check'],
            prop: 'check',
            label: '复核',
            method: 'check'
          },
          {
            permissionSigns: ['payment_voucher_uncheck'],
            prop: 'unCheck',
            label: '反复核',
            method: 'unCheck'
          },
          {
            permissionSigns: ['payment_voucher_check'],
            prop: 'reimburse',
            label: '报销',
            method: 'reimburse'
          },
          {
            permissionSigns: ['payment_voucher_delete'],
            prop: 'remove',
            label: '作废',
            method: 'remove'
          },
          {
            permissionSigns: ['payment_voucher_view'],
            prop: 'print',
            label: '打印',
            method: 'print'
          },
          {
            permissionSigns: ['payment_voucher_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['payment_voucher_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            payerName: '',
            unitName: '',
            searchStartDate: '',
            searchEndDate: '',
            payMethod: '',
            isReimburse: '',
            status: ''
          }
        }
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['payment_voucher_add'],
          label: '待付款清单',
          method: 'todoPaid',
          count: 0
        },
        {
          permissionSigns: ['payment_voucher_check'],
          label: '待复核的付款单',
          method: 'todoCheck',
          count: 0
        },
        {
          permissionSigns: ['payment_voucher_check'],
          label: '待报销的付款单',
          method: 'todoReimburse',
          count: 0
        },
        {
          permissionSigns: ['payer_setting_view'],
          label: '付款方设置',
          method: 'managePayer',
          hide: true
        }
      ],
      payMethodOptions: [{ value: 1, label: '对公转账' }, { value: 3, label: '个人垫付' }],
      payChannelOptions: [{ value: 1, label: '网银' }, { value: 2, label: '微信' }, { value: 3, label: '支付宝' }, { value: 4, label: '现金' }],
      isReimburseOptions: [{ value: 1, label: '已报销' }, { value: 0, label: '未报销' }, { value: 2, label: '不报销' }],
      statusOptions: [{ value: 1, label: '制单' }, { value: 2, label: '复核' }],
      id: null, // 选中的单据ID
      eventType: '',
      dialogTitle: '',
      dialogEditVisible: false,
      dialogEditRedVisible: false,
      dialogReimburseVisible: false,
      dialogViewVisible: false,
      dialogTaskVisible: false, // 待付款任务清单
      dialogTaskCheckVisible: false, // 待复核任务清单
      dialogTaskReimburseVisible: false, // 待报销任务清单
      dialogPrintVisible: false, // 打印报销单
      dialogManagePayerVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'pv.province_name', width: 90 },
      { prop: 'cityName', label: '城市', filterColumn: 'pv.city_name', width: 100 },
      { prop: 'payerName', label: '付款方', filterColumn: 'pv.payer_name', width: 150 },
      { prop: 'projectNames', label: '支付项目', filterColumn: 'pv.project_names', width: 200 },
      { prop: 'payMethodValue', label: '付款方式', filterColumn: 'pv.pay_method', filterValue: 'payMethod', filterArray: this.payMethodOptions, width: 105 },
      { prop: 'payChannelValue', label: '支付渠道', filterColumn: 'pv.pay_channel', filterValue: 'payChannel', filterArray: this.payChannelOptions, width: 105 },
      { prop: 'payBankName', label: '付款银行', filterColumn: 'pv.pay_bank_name', width: 150 },
      { prop: 'payBankNo', label: '付款账号', filterColumn: 'pv.pay_bank_no', width: 140 },
      { prop: 'unitName', label: '收款单位', filterColumn: 'u.unit_name', width: 150 },
      { prop: 'unitBankName', label: '收款银行', filterColumn: 'pv.unit_bank_name', width: 150 },
      { prop: 'unitBankNo', label: '收款账号', filterColumn: 'pv.unit_bank_no', width: 140 },
      { prop: 'payDateValue', label: '付款日期', filterColumn: 'pv.pay_date', width: 110, isBetween: true },
      { prop: 'payAmount', label: '付款金额', filterColumn: 'pv.pay_amount', width: 110, formatPrice: true },
      { prop: 'isReimburseValue', label: '报销情况', filterColumn: 'pv.is_reimburse', filterValue: 'isReimburse', filterArray: this.statusOptions, width: 105 },
      { prop: 'reimburseDateValue', label: '报销日期', filterColumn: 'pv.reimburse_date', width: 110, isBetween: true },
      { prop: 'statusValue', label: '状态', filterColumn: 'pv.status', filterValue: 'status', filterArray: this.statusOptions, width: 100 },
      { prop: 'remark', label: '备注', filterColumn: 'pv.remark', width: 180 },
      { prop: 'creator', filterColumn: 'pv.creator', label: '制单人', width: 100 },
      { prop: 'createTimeValue', filterColumn: 'pv.create_time', label: '制单时间', width: 150, isBetween: true },
      { prop: 'checker', filterColumn: 'pv.checker', label: '复核人', width: 100 },
      { prop: 'checkTimeValue', filterColumn: 'pv.check_time', label: '复核时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      loadPaymentVoucherListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        data.forEach(item => {
          if (item.billType === 2) {
            item.fontColor = 'blue'
          } else if (item.billType === 3) {
            item.fontColor = 'red'
          }
        })
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      // 待付款清单数量
      countPayableTodoNumberApi({ todoPay: 'true' }).then(res => {
        this.todoList[0].count = res.data || 0
      })
      // 待复核付款单数量
      countPaymentVoucherTodoNumberApi({ status: 1 }).then(res => {
        this.todoList[1].count = res.data || 0
      })
      // 待报销的付款单数量
      countPaymentVoucherTodoNumberApi({ isReimburse: 0, status: 2 }).then(res => {
        this.todoList[2].count = res.data || 0
      })
    },
    // 付款待办
    todoPaidFun () {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 复核待办
    todoCheckFun () {
      this.dialogTaskCheckVisible = !this.dialogTaskCheckVisible
    },
    // 报销待办
    todoReimburseFun () {
      this.dialogTaskReimburseVisible = !this.dialogTaskReimburseVisible
    },
    // 付款方管理
    managePayerFun () {
      this.dialogManagePayerVisible = !this.dialogManagePayerVisible
    },
    //红字新增
    addFun(){
      this.id = null
      this.eventType = 'add'
      this.dialogTitle = '新增红字付款单'
      this.dialogEditRedVisible = !this.dialogEditRedVisible
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要修改的付款单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '付款单不在制单状态，不能修改', type: 'warning' })
        return
      } else if (Number(getUserId()) !== 1 && Number(getUserId()) !== 55 && Number(getUserId()) !== 147 && Number(getUserId()) !== 347 && Number(getUserId()) !== 352 && Number(getUserId()) !== Number(args[0].paymentHandler)) {
        this.$message({ message: '您不是指定的付款经办人，不能修改', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      if(args[0].billType === 1){
        this.dialogTitle = '修改付款单'
        this.dialogEditVisible = !this.dialogEditVisible
      } else {
        this.dialogTitle = '修改红字付款单'
        this.dialogEditRedVisible = !this.dialogEditRedVisible
      }
    },
    // 报销
    reimburseFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要报销的付款单', type: 'warning' })
        return
      } else if (args[0].status === 1) {
        this.$message({ message: '付款单不在复核状态，不能报销', type: 'warning' })
        return
      } else if (args[0].isReimburse === 2) {
        this.$message({ message: '付款单设置为不报销，不能报销', type: 'warning' })
        return
      }

      this.id = args[0].id
      this.eventType = 'reimburse'
      this.dialogTitle = '更新付款单报销情况'
      this.dialogReimburseVisible = !this.dialogReimburseVisible
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的付款单', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogTitle = '查看付款单'
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 打印报销单
    printFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要打印报销单的付款单', type: 'warning' })
        return
      } else if (args[0].isReimburse === 2) {
        this.$message({ message: '该付款单不需要报销，请不要打印', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogTitle = '打印报销单'
      this.dialogPrintVisible = !this.dialogPrintVisible
    },
    // 作废
    removeFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要作废的付款单', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        this.$message({ message: '付款单不在制单状态，不能作废', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定作废该付款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdatePaymentVoucherApi({ id: args[0].id, isDelete: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 复核
    checkFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要复核的付款单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '付款单不在制单状态，不能复核', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定复核该付款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdatePaymentVoucherApi({ id: args[0].id, isCheck: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 反复核
    unCheckFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要反复核的付款单', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        this.$message({ message: '付款单不在复核状态，不能反复核', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定反复核该付款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdatePaymentVoucherApi({ id: args[0].id, isUnCheck: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      loadPaymentVoucherExportDataApi({ condition: JSON.stringify(this.exportObj) }).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
